import { Container, Grid, Paper, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from '../../../types/store';

import CreateSpeakerGameForm from "./gameform-speaker";
import HeaderWithBackNav from "../../../components/ui-header-back";
import FlexCenter from "../../../components/flex/flex-center";
import GameCategoryInfoDisplay from "../../../components/gamecategory/game-category-info";
import AppConstants from '../../../constants/app-constants';

export default function CreateStandard() {
    const theme = useTheme();
    const translate = useSelector((state:RootState) => state.ui.language.create);
    
    return (
        <Paper elevation={3} sx={{backgroundColor: theme.palette.secondary.dark, minHeight: "40rem"}}>
            <Grid container>
                <Grid size={{xs: 12, md: 6}}>
                    <Container maxWidth="sm">
                        <FlexCenter direction="column">
                            <HeaderWithBackNav size="md" text={translate.createSpeaker} />
                            <CreateSpeakerGameForm />
                        </FlexCenter>
                    </Container>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <GameCategoryInfoDisplay gameMode={AppConstants.GAMEMODE_SPEAKER} />
                </Grid>
            </Grid>
        </Paper>
    );
}
